export default __webpack_public_path__ + "static/media/whatsapp-usage.a566048e.svg";